// import React, { useState } from "react";
// import { signInWithEmailAndPassword, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
// import { auth } from "./firebase";
// import { useNavigate } from "react-router-dom";
// import './login.css'; 

// const Login = () => {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [error, setError] = useState("");
//   const navigate = useNavigate();

//   const handleLogin = async (e) => {
//     e.preventDefault();
//     try {
//       await signInWithEmailAndPassword(auth, email, password);
//       alert("Login successful!");
//       navigate("/tools"); // Redirect to MainPage after login
//     } catch (err) {
//       setError(err.message);
//     }
//   };

//   const handleGoogleSignIn = async () => {
//     try {
//       const googleProvider = new GoogleAuthProvider();
//       const result = await signInWithPopup(auth, googleProvider);
//       console.log("Google Sign-in successful:", result.user);
//       alert("Login successful!");
//       navigate("/tools");
//     } catch (err) {
//       setError(err.message);
//     }
//   };

//   return (
//     <>
//     <div className="animated-bgut"> {/* This will hold the moving shapes */}
//             <div className="circleut circle1ut"></div>
//             <div className="circleut circle2ut"></div>
//             <div className="circleut circle3ut"></div>
//             <div className="circleut circle4ut"></div>
//             <div className="circleut circle5ut"></div>
//             <div className="circlesut circles1ut"></div>
//             <div className="circlessut circles2ut"></div>
//     </div>
//     <div className="login-container">
     
//       <h2>Login</h2>
//       <form onSubmit={handleLogin} className="login-form">
//         <input 
//           type="email" 
//           placeholder="Email" 
//           value={email} 
//           onChange={(e) => setEmail(e.target.value)} 
//           required 
//           className="login-input"
//         />
//         <input 
//           type="password" 
//           placeholder="Password" 
//           value={password} 
//           onChange={(e) => setPassword(e.target.value)} 
//           required 
//           className="login-input"
//         />
//         <button type="submit" className="login-button">Login</button>
//       </form>

//       <div className="divider">
//         <span>OR</span>
//       </div>

//       <button 
//         onClick={handleGoogleSignIn} 
//         className="google-signin-button"
//       >
//         <img 
//           src={`${process.env.PUBLIC_URL}/images/googleicon.png`} 
//           alt="Google" 
//           className="google-icon"
//         />
//         Sign in with Google
//       </button>

//       {error && <p className="error-message">{error}</p>}
//     </div>
//     </>
//   );
// };

// export default Login;


import React, { useState, useEffect } from "react";
import { signInWithEmailAndPassword, signInWithPopup, GoogleAuthProvider, onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebase";
import { useNavigate } from "react-router-dom";
import './login.css';

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  // Gallery images array
  const galleryImages = [
    'image6.png', 'image7.png', 'image8.png', 
    'image9.png', 'image10.png', 'image11.png', 
    'image12.png'
  ];

  // Check if user is already logged in
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        navigate("/tools");
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate("/tools");
    } catch (err) {
      setError(err.message);
    }
  };

  const handleGoogleSignIn = async () => {
    try {
      const googleProvider = new GoogleAuthProvider();
      await signInWithPopup(auth, googleProvider);
      navigate("/tools");
    } catch (err) {
      setError(err.message);
    }
  };

  // Render gallery with shifted slices
  const renderGallerySet = () => {
    return (
      <>
        <div className="gallery-row">
          {galleryImages.slice(0, 5).map((img, index) => (
            <img 
              key={`set1-${index}`}
              src={`${process.env.PUBLIC_URL}/images/${img}`}
              alt={`Gallery ${index + 6}`}
              className="gallery-image"
            />
          ))}
        </div>
        <div className="gallery-row">
          {[...galleryImages.slice(3), ...galleryImages.slice(0, 2)].map((img, index) => (
            <img 
              key={`set2-${index}`}
              src={`${process.env.PUBLIC_URL}/images/${img}`}
              alt={`Gallery ${index + 9}`}
              className="gallery-image"
            />
          ))}
        </div>
        <div className="gallery-row">
          {[...galleryImages.slice(1), ...galleryImages.slice(0, 3)].map((img, index) => (
            <img 
              key={`set3-${index}`}
              src={`${process.env.PUBLIC_URL}/images/${img}`}
              alt={`Gallery ${index + 7}`}
              className="gallery-image"
            />
          ))}
        </div>
      </>
    );
  };

  return (
    <>
      <div className="animated-blgint">
        <div className="gallery-tracklogin">
          {renderGallerySet()}
          {renderGallerySet()} {/* duplicate for seamless animation */}
        </div>
      </div>

      <div className="login-container">
        <h2>Login</h2>
        <form onSubmit={handleLogin} className="login-form">
          <input 
            type="email" 
            placeholder="Email" 
            value={email} 
            onChange={(e) => setEmail(e.target.value)} 
            required 
            className="login-input"
          />
          <input 
            type="password" 
            placeholder="Password" 
            value={password} 
            onChange={(e) => setPassword(e.target.value)} 
            required 
            className="login-input"
          />
          <button type="submit" className="login-button">Login</button>
        </form>

        <div className="divider">
          <span>OR</span>
        </div>

        <button onClick={handleGoogleSignIn} className="google-signin-button">
          <img 
            src={`${process.env.PUBLIC_URL}/images/googleicon.png`} 
            alt="Google" 
            className="google-icon"
          />
          Sign in with Google
        </button>

        {error && <p className="error-message">{error}</p>}
      </div>
    </>
  );
};

export default Login;





// import React, { useState } from "react";
// import { signInWithEmailAndPassword, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
// import { auth } from "./firebase";
// import { useNavigate } from "react-router-dom";
// import './login.css';

// const Login = () => {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [error, setError] = useState("");
//   const navigate = useNavigate();

//   // Gallery images array
//   const galleryImages = [
//     'image6.png', 'image7.png', 'image8.png', 
//     'image9.png', 'image10.png', 'image11.png', 
//     'image12.png'
//   ];

//   // Duplicate the array for seamless looping
//   const duplicatedImages = [...galleryImages, ...galleryImages];

//   const handleLogin = async (e) => {
//     e.preventDefault();
//     try {
//       await signInWithEmailAndPassword(auth, email, password);
//       navigate("/tools");
//     } catch (err) {
//       setError(err.message);
//     }
//   };

//   const handleGoogleSignIn = async () => {
//     try {
//       const googleProvider = new GoogleAuthProvider();
//       await signInWithPopup(auth, googleProvider);
//       navigate("/tools");
//     } catch (err) {
//       setError(err.message);
//     }
//   };

//   // Create gallery rows with different image combinations
//   // const galleryImages = [
//   //   'image6.png', 'image7.png', 'image8.png', 
//   //   'image9.png', 'image10.png', 'image11.png', 
//   //   'image12.png'
//   // ];

//   // Create a single complete set of rows
//   const renderGallerySet = () => {
//     return (
//       <>
//         <div className="gallery-row">
//           {galleryImages.slice(0, 5).map((img, index) => (
//             <img 
//               key={`set1-${index}`}
//               src={`${process.env.PUBLIC_URL}/images/${img}`}
//               alt={`Gallery ${index + 6}`}
//               className="gallery-image"
//             />
//           ))}
//         </div>
//         <div className="gallery-row">
//           {[...galleryImages.slice(3), ...galleryImages.slice(0, 2)].map((img, index) => (
//             <img 
//               key={`set2-${index}`}
//               src={`${process.env.PUBLIC_URL}/images/${img}`}
//               alt={`Gallery ${index + 9}`}
//               className="gallery-image"
//             />
//           ))}
//         </div>
//         <div className="gallery-row">
//           {[...galleryImages.slice(1), ...galleryImages.slice(0, 3)].map((img, index) => (
//             <img 
//               key={`set3-${index}`}
//               src={`${process.env.PUBLIC_URL}/images/${img}`}
//               alt={`Gallery ${index + 7}`}
//               className="gallery-image"
//             />
//           ))}
//         </div>
//       </>
//     );
//   };

//   return (
//     <>
//      <div className="animated-blgint">
//         <div className="gallery-tracklogin">
//           {renderGallerySet()}
//           {/* Exact duplicate for seamless looping */}
//           {renderGallerySet()}
//         </div>
//       </div>
      
//       <div className="login-container">
//         <h2>Login</h2>
//         <form onSubmit={handleLogin} className="login-form">
//           <input 
//             type="email" 
//             placeholder="Email" 
//             value={email} 
//             onChange={(e) => setEmail(e.target.value)} 
//             required 
//             className="login-input"
//           />
//           <input 
//             type="password" 
//             placeholder="Password" 
//             value={password} 
//             onChange={(e) => setPassword(e.target.value)} 
//             required 
//             className="login-input"
//           />
//           <button type="submit" className="login-button">Login</button>
//         </form>

//         <div className="divider">
//           <span>OR</span>
//         </div>

//         <button onClick={handleGoogleSignIn} className="google-signin-button">
//           <img 
//             src={`${process.env.PUBLIC_URL}/images/googleicon.png`} 
//             alt="Google" 
//             className="google-icon"
//           />
//           Sign in with Google
//         </button>

//         {error && <p className="error-message">{error}</p>}
//       </div>
//     </>
//   );
// };

// export default Login;